<template>
    <v-layout row>
      <v-btn
        flat
        icon
        v-if="! sample_order_line.feedback"
        color="red"
        disabled
      >
        <v-icon class="text--primary">announcement</v-icon>
      </v-btn>
        <v-dialog v-model="dialog" persistent max-width="800px">
            <v-btn
                    flat
                    icon
                    v-if="sample_order_line.feedback"
                    slot="activator"
            >
                <v-icon>announcement</v-icon>
            </v-btn>
            <v-card>
                <v-card-title>
                    <span class="headline">Feedback for sample: {{ sample_order_line.name }} ({{ sample_order_line.lc_code }})</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 s12 md12>
                                <p>{{ data.feedback }}</p>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        props: ['sample_order_id', 'sample_order_line'],
        data: () => ({
            dialog: false,
            data : {
                feedback: '',
                sample_order_id: null,
                sample_order_line_id: null
            },
            tieneFeedback: false
        }),
        created () {
        },
        watch: {
            dialog: function() {
                if (this.dialog == true) {
                    this.getFeedback();
                }
            }
        },
        methods: {
            getFeedback () {
                this.data.sample_order_id = this.sample_order_id;
                this.data.sample_order_line_id = this.sample_order_line.id;
                this.$store.dispatch('getSampleOrderLineFeedback', this.data).then((res) => {
                    this.data.feedback = res.data.data.feedback;
                    this.tieneFeedback = true;
                }).catch((error) => {

                });
            },
            create () {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.data.sample_order_id = this.sample_order_id;
                        this.data.sample_order_line_id = this.sample_order_line.id;
                        this.$store.dispatch('createSampleOrderLineFeedback', this.data).then((res) => {
                            this.tieneFeedback = true;
                            this.dialog = false
                        }).catch((error) => {

                        });
                    }
                });
            },
            cancel () {
                this.dialog = false;
                this.data = this.data = {
                    feedback: '',
                    sample_order_id: null,
                    sample_order_line_id: null
                };
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/fnt/samples/components/FeedbackComponent.vue